import { render } from "./TheUserAuthButton.vue?vue&type=template&id=201f5de0&scoped=true"
import script from "./TheUserAuthButton.vue?vue&type=script&lang=js"
export * from "./TheUserAuthButton.vue?vue&type=script&lang=js"

import "./TheUserAuthButton.vue?vue&type=style&index=0&id=201f5de0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\reimo\\Documents\\Projektide IT osa\\AccountaBuddy\\accounta-buddy-app-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201f5de0"]])

export default __exports__